import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const fetchEmailActivity = async data => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/email-activity`, {
    params: { token, ...data }
  })

  return response.data
}
